module.exports = __webpack_public_path__ + "img/appboxo_product_example.f544b6ee.png";